import LayoutLeftIcon from "@redotech/redo-icons/layout-left.svg";
import LayoutRightIcon from "@redotech/redo-icons/layout-right.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import ChevronLeftIcon from "@redotech/redo-web/icon-old/chevron-left.svg";
import { Text } from "@redotech/redo-web/text";
import { memo, type ReactNode } from "react";
import * as css from "./conversation-header.module.css";

export interface ConversationHeaderProps {
  actionToolbar?: ReactNode;
  customerName: string;
  ticketNumber: number | null;
  latestMessageTime: Date | null;
  leftPanelOpen?: boolean;
  onBack: () => void;
  onToggleLeftPanel?: () => void;
  onToggleRightPanel?: () => void;
  rightPanelOpen?: boolean;
}

export const ConversationHeader = memo(function ConversationHeader({
  actionToolbar,
  customerName,
  ticketNumber,
  latestMessageTime,
  leftPanelOpen,
  onBack,
  onToggleLeftPanel,
  onToggleRightPanel,
  rightPanelOpen,
}: ConversationHeaderProps) {
  return (
    <Flex
      align="center"
      bgColor="primary"
      borderBottomWidth="1px"
      borderColor="secondary"
      borderStyle="solid"
      className={css.header}
      gap="md"
      justify="space-between"
      overflow="hidden"
      pl="xl"
      pr="md"
      shrink={0}
    >
      <Flex align="center" gap="md" minW="none" overflow="hidden">
        {!leftPanelOpen && onToggleLeftPanel && (
          <RedoButton
            hierarchy="tertiary"
            IconLeading={LayoutLeftIcon}
            onClick={onToggleLeftPanel}
            size="sm"
          />
        )}
        <RedoButton
          hierarchy="secondary"
          IconLeading={ChevronLeftIcon}
          onClick={onBack}
          size="sm"
        />
        {ticketNumber && (
          <Text
            fontSize="md"
            fontWeight="semibold"
            textColor="primary"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {`#${ticketNumber}`}
          </Text>
        )}
        <Text
          fontSize="md"
          fontWeight="regular"
          textColor="primary"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {customerName}
        </Text>
      </Flex>
      <Flex align="center" gap="sm" shrink={0}>
        {latestMessageTime && (
          <Text fontSize="sm" textColor="tertiary" whiteSpace="nowrap">
            {latestMessageTime.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            }) +
              " at " +
              latestMessageTime.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
          </Text>
        )}
        {actionToolbar}
        {!rightPanelOpen && onToggleRightPanel && (
          <RedoButton
            hierarchy="tertiary"
            IconLeading={LayoutRightIcon}
            onClick={onToggleRightPanel}
            size="sm"
          />
        )}
      </Flex>
    </Flex>
  );
});
